/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Subscription_Link_Delete_Account_TitleInputs */

const en_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original Account Deleted`)
};

const ar_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحساب الأصلي محذوف`)
};

const de_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ursprüngliches Konto gelöscht`)
};

const es_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta original eliminada`)
};

const fr_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte d'origine supprimé`)
};

const it_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account originale eliminato`)
};

const ja_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元のアカウントが削除されました`)
};

const ko_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`원래 계정이 삭제되었습니다`)
};

const pt_br_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta original excluída`)
};

const ru_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исходный аккаунт удален`)
};

const th_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีเดิมถูกลบแล้ว`)
};

const tr_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orijinal Hesap Silindi`)
};

const zh_cn_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原账号已被删除`)
};

const zh_tw_dialog_subscription_link_delete_account_title = /** @type {(inputs: Dialog_Subscription_Link_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原帳號已被刪除`)
};

/**
* | output |
* | --- |
* | "Original Account Deleted" |
*
* @param {Dialog_Subscription_Link_Delete_Account_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_subscription_link_delete_account_title = /** @type {((inputs?: Dialog_Subscription_Link_Delete_Account_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Subscription_Link_Delete_Account_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_subscription_link_delete_account_title(inputs)
	if (locale === "ar") return ar_dialog_subscription_link_delete_account_title(inputs)
	if (locale === "de") return de_dialog_subscription_link_delete_account_title(inputs)
	if (locale === "es") return es_dialog_subscription_link_delete_account_title(inputs)
	if (locale === "fr") return fr_dialog_subscription_link_delete_account_title(inputs)
	if (locale === "it") return it_dialog_subscription_link_delete_account_title(inputs)
	if (locale === "ja") return ja_dialog_subscription_link_delete_account_title(inputs)
	if (locale === "ko") return ko_dialog_subscription_link_delete_account_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_subscription_link_delete_account_title(inputs)
	if (locale === "ru") return ru_dialog_subscription_link_delete_account_title(inputs)
	if (locale === "th") return th_dialog_subscription_link_delete_account_title(inputs)
	if (locale === "tr") return tr_dialog_subscription_link_delete_account_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_subscription_link_delete_account_title(inputs)
	return zh_tw_dialog_subscription_link_delete_account_title(inputs)
});